import styled from '@emotion/styled';
import { css } from '@emotion/core';

export const SwiperOuter = styled.div`
  height: auto;
  visibility: visible;
  width: 100%;
  position: relative;
  max-width: 480px;
  margin: 24px auto 12px;

  ${({ isDrawingEnabled }) =>
    isDrawingEnabled &&
    `
    height: 0;
    visibility: hidden;
  `}

  ${({ theme }) => theme.breakpoints.md.up} {
    display: none;
  }
`;

export const SwiperInner = styled.div`
  display: block;
`;

export const IndicatorTitle = styled.h5`
  font-size: 22px;
  line-height: 1.25;
  margin: 0 auto;
  text-align: center;
  padding: 0 24px;
`;

export const IndicatorLabel = styled.h6`
  font-size: 16px;
  line-height: 1.25;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.grey60};
  margin: 8px auto;
  text-align: center;
  padding: 0 24px;
  hyphens: auto;
`;

export const IndicatorSource = styled.aside`
  font-size: 14px;
  line-height: 1.25;
  color: ${({ theme }) => theme.colors.grey60};
  margin: 0 auto;
  text-align: center;
  padding: 0 24px;
`;

export const IndicatorText = styled.p`
  font-family: ${({ theme }) => theme.fonts.serif};
  font-size: 16px;
  line-height: 1.5;
  color: ${({ theme }) => theme.colors.black};
  margin: 4px auto 12px;
  padding: 0 8px;
  text-align: center;
`;

const sharedButtonStyles = ({ theme }) => css`
  ${theme.snippets.resetButton};

  svg {
    width: 13px;
    height: 29px;
  }

  position: absolute;
  top: -12px;
  z-index: 99;
`;

export const PlainNextButton = styled.button`
  ${sharedButtonStyles}
  text-align: right;
  right: 0;
  padding: 9px 6px 6px 12px;
`;

export const PlainPrevButton = styled.button`
  ${sharedButtonStyles}
  left: 0;
  text-align: left;
  padding: 9px 12px 6px 6px;
`;

export const SelectedIndicatorInfo = styled.div`
  position: relative;
`;
